// extracted by mini-css-extract-plugin
export default {"user":"User_user__719fb","input":"User_input__rh7+w","button":"User_button__sSTMT"};